<template>
  <div class="member">
    <div class="user">
      <img :src="userInfo.avatar" alt="">
      {{userInfo.nickname}}
    </div>
    <div class="desc" v-if="userInfo && userInfo.level_pic_three.length > 0">
      <div class="box">
        <div class="level">
          <img :src="userInfo.level_pic_three" alt="" width="100%">
          <div class="words">已打败{{userInfo.win_user * 100}}%的用户</div>
        </div>
        <div class="medal">
          <img :src="userInfo.medal_three" alt="">
        </div>
        <div class="exp">
          <div style="font-size: .24rem"><span>{{userInfo.exp}}</span>/{{userInfo.next_level_exp}}</div>
          <div class="process"><div :style="{width:userInfo.expPecent}"></div></div>
          <div>再获取{{userInfo.need_exp}}经验值可升级</div>
        </div>
      </div>
      <div class="data">
        <div class="item">
          <p class="bold fs-24"><span class="fs-32">{{userInfo.join_aly_day}}</span>天</p>
          <p class="fs-20">加入俺来也</p>
        </div>
        <div class="item">
          <p class="bold fs-24"><span class="fs-32">{{userInfo.order_time}}</span>次</p>
          <p class="fs-20">累计下单</p>
        </div>
        <div class="item">
          <p class="bold">¥<span class="fs-32">{{userInfo.order_money}}</span></p>
          <p class="fs-20">累计消费</p>
        </div>
        <!--<div class="item">-->
          <!--<p class="bold fs-24"><span class="fs-32">{{userInfo.acj_time}}</span>次</p>-->
          <!--<p class="fs-20">参加爱吃节</p>-->
        <!--</div>-->
        <!--<div class="item">-->
          <!--<p class="bold">¥<span class="fs-32">{{userInfo.acj_save_money}}</span></p>-->
          <!--<p class="fs-20">爱吃节共省</p>-->
        <!--</div>-->
      </div>
    </div>
    <div class="get-ways">
      <div class="title"><img src="../assets/images/get-ways.png" alt=""></div>
      <div class="date">2021年01月08日生效</div>
      <ul>
        <li>
          <img src="../assets/images/icon-qiandao.png" alt="">
          <div class="words">
            <p class="fs-28 c-000">每日签到</p>
            <p><span class="c-FF9E00">+5</span>经验/天，连续签到<span class="c-FF9E00">+8</span>经验/天</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/icon-xndc.png" alt="">
          <div class="words">
            <p class="fs-28 c-000">校内订餐</p>
            <p>每单每元<span class="c-FF9E00">+1</span>经验，上限<span class="c-FF9E00">+10</span>经验/单</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/icon-ddpj.png" alt="">
          <div class="words">
            <p class="fs-28 c-000">订单评价</p>
            <p><span class="c-FF9E00">+5</span>经验/每单评价</p>
          </div>
        </li>
        <!--<li>-->
          <!--<img src="../assets/images/icon-fqly.png" alt="">-->
          <!--<div class="words">-->
            <!--<p class="fs-28 c-000">饭圈留言</p>-->
            <!--<p><span class="c-FF9E00">+5</span>经验，每日留言</p>-->
          <!--</div>-->
        <!--</li>-->
        <li>
          <img src="../assets/images/icon-wstx.png" alt="">
          <div class="words">
            <p class="fs-28 c-000">完善社区资料头像昵称</p>
            <p><span class="c-FF9E00">+10</span>经验，仅限获得一次</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/icon-xxx.png" alt="">
          <div class="words">
            <p class="fs-28 c-000">申请西游侠</p>
            <p><span class="c-FF9E00">+20</span>经验</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/icon-mrsd.png" alt="">
          <div class="words">
            <p class="fs-28 c-000">每日送单</p>
            <p><span class="c-FF9E00">+2</span>经验，上限<span class="c-FF9E00">+10</span>经验</p>
          </div>
        </li>
      </ul>
      <div style="text-align: center"><div class="btn" @click="viewExp()">查看升级所需经验</div></div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  export default {
    data () {
      return {
        userInfo: {}
      }
    },
    created () {
      this.getLevel()
    },
    methods: {
      getLevel () {
        let _this = this
        actions.getLevel(_this, {uid: localStorage.getItem('wxUid')}, function (data) {
          _this.userInfo = data
          _this.userInfo.expPecent = (data.exp / data.next_level_exp) * 100 + '%'
        })
      },
      viewExp () {
        this.$router.push({ name: 'ExpDesc' })
      }
    }

  }
</script>
<style scoped>
  .bold{
    font-weight: bold;
  }
  .c-000{
    color: #000;
  }
  .c-FF9E00{
    color: #FF9E00;
  }
  .fs-32{
    font-size: .32rem;
  }
  .fs-28{
    font-size: .28rem;
  }
  .fs-24{
    font-size: .24rem;
  }
  .fs-20{
    font-size: .2rem;
  }
  .member{
    padding: .39rem .15rem;
    background-color: #fff;
    color: #2F2F2F;
  }
  .member .user{
    padding-left: .23rem;
    line-height: .82rem;
    font-size: .32rem;
    /*color: #2F2F2F;*/
  }
  .member .user img{
    display: inline-block;
    width: .82rem;
    height: .82rem;
    margin-right: .18rem;
    background: rgba(0,0,0,0.10);
    /*border: .04rem solid #2F2F2F;*/
    border-radius: 2rem;
    vertical-align: middle;
  }
  .member .desc{
    width: 100%;
    height: 5.8rem;
    margin-top: .86rem;
    background: #FF9E00;
    border: .06rem solid #2F2F2F;
    border-radius: .24rem;
  }
  .member .desc .box{
    position: relative;
    height: 4.45rem;
    margin: -.5rem .1rem 0 .1rem;
    background: #FFDF00;
    border: .06rem solid #2F2F2F;
    border-radius: .24rem;
  }
  .member .desc .box .level{
    position: relative;
    width: 3.5rem;
    /*height: 1.12rem;*/
    /*padding-left: .16rem;*/
    margin-top: .38rem;
    /*background: #2F2F2F;*/
    font-size: .22rem;
    color: #FFFFFF;
    border-radius: 0 .66rem .66rem 0;
  }
  .member .desc .box .level .words{
    position: absolute;
    left: .16rem;
    bottom: .2rem;
  }
  .member .desc .box .medal{
    position: absolute;
    width: 1.6rem;
    right: .25rem;
    top: -.2rem;
  }
  .member .desc .box .exp{
    margin-left: .16rem;
    margin-top: .74rem;
    font-size: .22rem;
    /*color: #2F2F2F;*/
  }
  .member .desc .box .exp span{
    font-size: .42rem;
    font-weight: bold;
    margin-right: .08rem;
  }
  .member .desc .box .exp .process{
    width: 4.26rem;
    height: .22rem;
    margin-bottom: .15rem;
    background: #FF9E00;
    border: .04rem solid #2F2F2F;
    border-radius: .12rem;
  }
  .member .desc .box .exp .process div{
    /*display: inline-block;*/
    width: 30%;
    height: .14rem;
    background: #FFFFFF;
    border-right: .04rem solid #2F2F2F;
    border-radius: .12rem;
  }
  .member .desc .data{
    display: flex;
    width: 100%;
    padding: .5rem 0;
  }
  .member .desc .data .item{
    position: relative;
    flex: 1;
  }
  .member .desc .data .item:after{
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    width: .04rem;
    height: .2rem;
    background: #2F2F2F;
  }
  .member .desc .data .item:last-child:after{
    display: none;
  }
  .member .desc .data .item p{
    margin: 0;
    padding: 0;
    /*font-size: .2rem;*/
    text-align: center;
  }
  .member .get-ways{
    position: relative;
    width: 100%;
    border: .06rem solid #2F2F2F;
    border-radius: .24rem;
    margin-top: 1.1rem;
  }
  .member .get-ways .title{
    position: absolute;
    width: 3.93rem;
    height: .79rem;
    top: -.43rem;
    left: 50%;
    margin-left: -1.96rem;
  }
  .member .get-ways .date{
    font-size: .24rem;
    color: #ED5A3C;
    text-align: center;
    margin-top: .72rem;
  }
  .member .get-ways ul{
    padding: .25rem 0 0 .36rem;
  }
  .member .get-ways ul li{
    margin-bottom: .48rem;
  }
  .member .get-ways ul li img{
    float: left;
    width: .66rem;
    height: .66rem;
  }
  .member .get-ways ul li .words{
    margin-left: .85rem;
    color: #2E2E2E;
    font-size: .22rem;
  }
  .member .get-ways ul li .words p{
    padding: 0;
    margin: 0;
  }
  .member .get-ways ul li .words p:last-child{
    margin-top: .06rem;
  }
  .member .get-ways .btn{
    width: 4.4rem;
    height: .72rem;
    line-height: .72rem;
    padding: 0;
    margin: .05rem 0 .6rem 0;
    background: #FFDF00;
    border-radius: .36rem;
    font-size: .28rem;
    color: #111111;
  }
</style>



// WEBPACK FOOTER //
// MemberLevel.vue?d992dc74